export enum DataStatus {
  NORMAL,
  LOADING,
  EMPTY,
  ERROR,
  NO_WALLET,
}
